import { toJalaliDate } from "../../../middleware/middleware";

/** برآورد تقریبی — فقط نمایشی تا فیلد رسمی از API اضافه شود */
const BASE_TOTAL_CALENDAR_DAYS = 37;

function addCalendarDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function formatTimeRemaining(targetDate) {
  if (!targetDate) return null;
  const diffMs = targetDate.getTime() - Date.now();
  if (diffMs <= 0) return "به زودی";

  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays === 1) return "۱ روز";
  if (diffDays < 7) return `${diffDays.toLocaleString("fa-IR")} روز`;
  if (diffDays < 30) {
    const weeks = Math.max(1, Math.round(diffDays / 7));
    return `${weeks.toLocaleString("fa-IR")} هفته`;
  }
  const months = Math.max(1, Math.round(diffDays / 30));
  return `حدود ${months.toLocaleString("fa-IR")} ماه`;
}

export function estimateCommissioning(request, activeIndex, totalSteps) {
  const confirm = request?.requestConfirm;

  if (confirm === "Canceled") {
    return {
      available: false,
      dateLabel: null,
      timeRemainingLabel: null,
      isEstimate: false,
    };
  }

  if (confirm === "Completed") {
    const completedDate = request?.beginDate || request?.updateOn || request?.createOn;
    return {
      available: true,
      dateLabel: toJalaliDate(completedDate) || "—",
      timeRemainingLabel: "تکمیل شده",
      isEstimate: false,
    };
  }

  const remainingRatio =
    totalSteps <= 1
      ? 0.5
      : Math.max(0, (totalSteps - activeIndex - 1) / Math.max(1, totalSteps - 1));

  const remainingDays = Math.max(
    14,
    Math.round(BASE_TOTAL_CALENDAR_DAYS * (0.35 + remainingRatio * 0.65))
  );
  const estimatedDate = addCalendarDays(new Date(), remainingDays);

  return {
    available: true,
    dateLabel: toJalaliDate(estimatedDate),
    timeRemainingLabel: formatTimeRemaining(estimatedDate),
    isEstimate: true,
    estimatedDate,
  };
}
